/* ==========================================================================
   Lineage Seeds — shared behaviour (all pages)
   Zero-dependency. Every block is null-guarded so it no-ops on pages that
   don't include a given component.
   ========================================================================== */
(function () {
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- On-view reveal (bottom-up + fade) ---- */
  if ("IntersectionObserver" in window && !reduce) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" },
    );
    document.querySelectorAll("[data-anim]").forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll("[data-anim]").forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  /* ---- Category nav: sub-category dropdowns ----
     The list itself comes from a Shopify menu, so this only handles opening.
     Desktop already opens on hover/focus via CSS; the caret is what makes it
     reachable by tap and by keyboard, and what closes it again. */
  (function () {
    var carets = document.querySelectorAll("[data-subnav-toggle]");
    if (!carets.length) return;

    function closeAll(except) {
      document
        .querySelectorAll(".category-nav_item.is-open")
        .forEach(function (item) {
          if (item === except) return;
          item.classList.remove("is-open");
          var btn = item.querySelector("[data-subnav-toggle]");
          if (btn) btn.setAttribute("aria-expanded", "false");
        });
    }

    carets.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var item = btn.closest(".category-nav_item");
        if (!item) return;
        var open = !item.classList.contains("is-open");
        closeAll(item);
        item.classList.toggle("is-open", open);
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });

    document.addEventListener("click", function (e) {
      if (!e.target.closest(".category-nav_item")) closeAll();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var open = document.querySelector(".category-nav_item.is-open");
      if (!open) return;
      closeAll();
      var btn = open.querySelector("[data-subnav-toggle]");
      if (btn) btn.focus();
    });
  })();

  /* ---- Stat counters: numbers count up the first time they scroll in ----
     Reads the authored value ("100+", "05+", "1,200", "4.8k") and animates
     only the numeric part, keeping prefix, suffix, separators and any
     leading zeros exactly as typed in the theme editor. */
  (function () {
    var counters = document.querySelectorAll("[data-counter]");
    if (!counters.length || reduce || !("IntersectionObserver" in window))
      return;

    function build(el) {
      var raw = (el.textContent || "").trim();
      var m = raw.match(/^([^\d]*)(\d[\d.,]*?)([^\d]*)$/);
      if (!m) return null;
      var prefix = m[1],
        numStr = m[2],
        suffix = m[3];
      var grouped = numStr.indexOf(",") > -1;
      var plain = numStr.replace(/,/g, "");
      var target = parseFloat(plain);
      if (!isFinite(target)) return null;
      var dot = plain.indexOf(".");
      var decimals = dot > -1 ? plain.length - dot - 1 : 0;
      var intPart = dot > -1 ? plain.slice(0, dot) : plain;
      var pad = /^0\d/.test(intPart) ? intPart.length : 0;
      return {
        el: el,
        target: target,
        render: function (v) {
          var parts = v.toFixed(decimals).split(".");
          while (parts[0].length < pad) parts[0] = "0" + parts[0];
          if (grouped)
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return prefix + parts.join(".") + suffix;
        },
      };
    }

    function run(c) {
      var duration = 1600,
        started = null;
      c.el.textContent = c.render(0);
      function step(now) {
        if (started === null) started = now;
        var p = Math.min(1, (now - started) / duration);
        var e = 1 - Math.pow(1 - p, 3); // easeOutCubic
        c.el.textContent = c.render(c.target * e);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          var c = build(e.target);
          if (c) run(c);
        });
      },
      { threshold: 0.4 },
    );

    counters.forEach(function (el) {
      io.observe(el);
    });
  })();

  /* ---- FAQ accordion: exclusive open + smooth grid-rows ---- */
  document.querySelectorAll(".faq_question").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var item = btn.closest(".faq_item");
      var isOpen = item.classList.contains("is-open");
      document.querySelectorAll(".faq_item.is-open").forEach(function (i) {
        i.classList.remove("is-open");
        i.querySelector(".faq_question").setAttribute("aria-expanded", "false");
      });
      if (!isOpen) {
        item.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });

  /* ---- Search overlay (liquid glass) ---- */
  var searchOverlay = document.querySelector(".search-overlay");
  var searchInput =
    searchOverlay && searchOverlay.querySelector(".search-panel_input");
  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
    setTimeout(function () {
      searchInput && searchInput.focus();
    }, 60);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  document.querySelectorAll("[data-search-toggle]").forEach(function (b) {
    b.addEventListener("click", openSearch);
  });
  if (searchOverlay)
    searchOverlay.querySelectorAll("[data-search-close]").forEach(function (b) {
      b.addEventListener("click", closeSearch);
    });

  /* ---- Cart drawer ---- */
  function getCartDrawer() {
    return document.querySelector(".cart-drawer");
  }

  function openCart(e) {
    if (e && e.preventDefault) e.preventDefault();
    var drawer = getCartDrawer();
    if (drawer) {
      drawer.classList.add("is-open");
      document.body.style.overflow = "hidden";
    } else {
      window.location.href = "/cart";
    }
  }

  function closeCart(e) {
    if (e && e.preventDefault) e.preventDefault();
    var drawer = getCartDrawer();
    if (drawer) {
      drawer.classList.remove("is-open");
      document.body.style.overflow = "";
    }
  }

  function refreshCartDrawer() {
    return fetch("/?sections=header")
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (!data || !data.header) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(data.header, "text/html");

        var newDrawer = doc.querySelector(".cart-drawer");
        var curDrawer = getCartDrawer();
        if (newDrawer && curDrawer) {
          var wasOpen = curDrawer.classList.contains("is-open");
          curDrawer.innerHTML = newDrawer.innerHTML;
          if (wasOpen) {
            curDrawer.classList.add("is-open");
          }
        }

        var newCount = doc.querySelector(".navbar_cart-count");
        var curCounts = document.querySelectorAll(".navbar_cart-count");
        curCounts.forEach(function (c) {
          if (newCount) {
            c.textContent = newCount.textContent;
            if (newCount.hasAttribute("hidden")) {
              c.setAttribute("hidden", "");
            } else {
              c.removeAttribute("hidden");
            }
          }
        });
      })
      .catch(function (err) {
        console.error("Failed to refresh cart drawer:", err);
      });
  }

  // Delegated clicks for cart toggle, close, quantity changes, and remove
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-cart-toggle], .navbar_cart");
    if (toggle) {
      openCart(e);
      return;
    }

    var closeBtn = e.target.closest("[data-cart-close]");
    if (closeBtn) {
      closeCart(e);
      return;
    }

    var drawer = getCartDrawer();
    if (drawer && drawer.contains(e.target)) {
      var removeBtn = e.target.closest(".cart-item_remove");
      if (removeBtn) {
        e.preventDefault();
        var rHref = removeBtn.getAttribute("href");
        if (rHref) {
          fetch(rHref).then(function () {
            return refreshCartDrawer();
          });
        }
        return;
      }

      var qtyBtn = e.target.closest(".cart-qty_btn");
      if (qtyBtn) {
        e.preventDefault();
        var qHref = qtyBtn.getAttribute("href");
        if (qHref) {
          fetch(qHref).then(function () {
            return refreshCartDrawer();
          });
        }
        return;
      }
    }
  });

  // Close cart on Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeCart(e);
    }
  });

  // AJAX add-to-cart for product forms
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (
      form &&
      (form.classList.contains("product_form") ||
        (form.getAttribute("action") &&
          form.getAttribute("action").indexOf("/cart/add") !== -1))
    ) {
      e.preventDefault();
      var submitBtn = form.querySelector(
        "[data-add-btn], button[type='submit']",
      );
      if (submitBtn) submitBtn.disabled = true;

      var formData = new FormData(form);
      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Add to cart failed");
          return res.json();
        })
        .then(function () {
          return refreshCartDrawer();
        })
        .then(function () {
          openCart();
        })
        .catch(function (err) {
          console.error("AJAX add to cart error:", err);
          form.submit();
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    }
  });

  /* ---- Account dropdown ---- */
  var account = document.querySelector(".navbar_account");
  var accountBtn = account && account.querySelector("[data-account-toggle]");
  if (account && accountBtn) {
    accountBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = account.classList.toggle("is-open");
      accountBtn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("click", function (e) {
      if (!account.contains(e.target)) {
        account.classList.remove("is-open");
        accountBtn.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* ---- Side menu drawer — the "Discover More" pill on desktop, the
         hamburger on mobile, both open this ---- */
  var drawer = document.querySelector("[data-menu-drawer]");
  if (drawer) {
    var drawerPanel = drawer.querySelector(".menu-drawer_panel");
    var drawerOpeners = document.querySelectorAll("[data-menu-open]");
    var drawerLastFocus = null;

    var openDrawer = function () {
      drawerLastFocus = document.activeElement;
      drawer.classList.add("is-open");
      document.body.classList.add("is-menu-open");
      drawerOpeners.forEach(function (b) {
        b.setAttribute("aria-expanded", "true");
      });
      var first = drawerPanel.querySelector(".menu-drawer_close");
      if (first) first.focus();
    };

    var closeDrawer = function () {
      drawer.classList.remove("is-open");
      document.body.classList.remove("is-menu-open");
      drawerOpeners.forEach(function (b) {
        b.setAttribute("aria-expanded", "false");
      });
      if (drawerLastFocus) drawerLastFocus.focus();
    };

    drawerOpeners.forEach(function (btn) {
      btn.addEventListener("click", openDrawer);
    });
    drawer.querySelectorAll("[data-menu-close]").forEach(function (btn) {
      btn.addEventListener("click", closeDrawer);
    });
    drawerPanel.querySelectorAll("a[href]").forEach(function (a) {
      a.addEventListener("click", closeDrawer);
    });

    document.addEventListener("keydown", function (e) {
      if (!drawer.classList.contains("is-open")) return;
      if (e.key === "Escape") {
        closeDrawer();
        return;
      }
      if (e.key !== "Tab") return;

      /* keep focus inside the panel while it is open */
      var focusable = drawerPanel.querySelectorAll(
        "a[href], button:not([disabled])",
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* ---- Currency / language selects ---- */
  document.querySelectorAll("[data-select]").forEach(function (sel) {
    var toggle = sel.querySelector("[data-select-toggle]");
    var valueEl = sel.querySelector("[data-select-value]");
    if (!toggle) return;
    toggle.addEventListener("click", function (e) {
      e.stopPropagation();
      document.querySelectorAll("[data-select].is-open").forEach(function (o) {
        if (o !== sel) {
          o.classList.remove("is-open");
          o.querySelector("[data-select-toggle]").setAttribute(
            "aria-expanded",
            "false",
          );
        }
      });
      var open = sel.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    sel.querySelectorAll("[data-select-option]").forEach(function (opt) {
      opt.addEventListener("click", function (e) {
        e.preventDefault();
        if (valueEl)
          valueEl.textContent =
            opt.getAttribute("data-label") || opt.textContent;
        sel.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      });
    });
  });
  document.addEventListener("click", function (e) {
    document.querySelectorAll("[data-select].is-open").forEach(function (sel) {
      if (!sel.contains(e.target)) {
        sel.classList.remove("is-open");
        sel
          .querySelector("[data-select-toggle]")
          .setAttribute("aria-expanded", "false");
      }
    });
  });

  /* ---- Product page: gallery thumbnails + variant + quantity ---- */
  var gallery = document.querySelector("[data-gallery]");
  if (gallery) {
    var main = gallery.querySelector("[data-gallery-main]");
    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll("[data-gallery-thumb]"),
    );
    var thumbTrack = gallery.querySelector("[data-thumbs-track]");
    var galleryIndex = 0;

    var showMedia = function (i) {
      if (!thumbs.length) return;
      galleryIndex = (i + thumbs.length) % thumbs.length;
      var thumb = thumbs[galleryIndex];

      thumbs.forEach(function (t) {
        t.classList.remove("is-active");
      });
      thumb.classList.add("is-active");

      if (main) {
        /* prefer the full-size URL — the thumb background is only 400px wide */
        var full = thumb.getAttribute("data-full");
        var next = full ? "url(" + full + ")" : thumb.style.backgroundImage;
        if (reduce) {
          main.style.backgroundImage = next;
        } else {
          main.classList.add("is-fading");
          setTimeout(function () {
            main.style.backgroundImage = next;
            main.classList.remove("is-fading");
          }, 180);
        }
      }

      /* keep the active thumb inside the strip */
      if (thumbTrack) {
        var tl = thumb.offsetLeft;
        var tr = tl + thumb.offsetWidth;
        if (
          tl < thumbTrack.scrollLeft ||
          tr > thumbTrack.scrollLeft + thumbTrack.clientWidth
        ) {
          thumbTrack.scrollTo({ left: tl - 8, behavior: "smooth" });
        }
      }
    };

    thumbs.forEach(function (t, i) {
      t.addEventListener("click", function () {
        showMedia(i);
        stopAuto();
      });
    });

    var prevBtn = gallery.querySelector("[data-gallery-prev]");
    var nextBtn = gallery.querySelector("[data-gallery-next]");
    prevBtn &&
      prevBtn.addEventListener("click", function () {
        showMedia(galleryIndex - 1);
        stopAuto();
      });
    nextBtn &&
      nextBtn.addEventListener("click", function () {
        showMedia(galleryIndex + 1);
        stopAuto();
      });

    /* ---- autoplay: pauses on hover, stops for good on interaction ---- */
    var autoSeconds = parseFloat(gallery.getAttribute("data-gallery-autoplay"));
    var autoTimer = null;

    function startAuto() {
      if (!autoSeconds || reduce || thumbs.length < 2 || autoTimer) return;
      autoTimer = setInterval(function () {
        showMedia(galleryIndex + 1);
      }, autoSeconds * 1000);
    }
    function pauseAuto() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }
    function stopAuto() {
      pauseAuto();
      autoSeconds = 0;
    }

    gallery.addEventListener("mouseenter", pauseAuto);
    gallery.addEventListener("mouseleave", startAuto);
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        pauseAuto();
      } else {
        startAuto();
      }
    });
    startAuto();
  }

  document.querySelectorAll("[data-variant-group]").forEach(function (group) {
    group.querySelectorAll("[data-variant]").forEach(function (opt) {
      opt.addEventListener("click", function () {
        group.querySelectorAll("[data-variant]").forEach(function (x) {
          x.classList.remove("is-active");
        });
        opt.classList.add("is-active");
      });
    });
  });
  document.querySelectorAll("[data-qty]").forEach(function (q) {
    var val = q.querySelector("[data-qty-val]");
    var btns = q.querySelectorAll("[data-qty-btn]");
    if (!val || btns.length < 2) return;
    var isInput = val.tagName === "INPUT";
    function get() {
      return +(isInput ? val.value : val.textContent) || 1;
    }
    function set(n) {
      if (isInput) {
        val.value = n;
      } else {
        val.textContent = n;
      }
    }
    btns[0].addEventListener("click", function () {
      set(Math.max(1, get() - 1));
    });
    btns[1].addEventListener("click", function () {
      set(get() + 1);
    });
  });

  /* ---- Product review carousel (slide + autoplay + clickable dots) ---- */
  document.querySelectorAll("[data-review]").forEach(function (root) {
    var track = root.querySelector("[data-review-track]");
    var slides = Array.prototype.slice.call(
      root.querySelectorAll("[data-review-slide]"),
    );
    var dots = Array.prototype.slice.call(
      root.querySelectorAll("[data-review-dot]"),
    );
    if (!track || !slides.length) return;
    var i = 0,
      timer = null;
    function show(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = "translateX(" + -100 * i + "%)";
      slides.forEach(function (s, k) {
        s.classList.toggle("is-active", k === i);
      });
      dots.forEach(function (d, k) {
        d.classList.toggle("is-active", k === i);
      });
    }
    function start() {
      if (!reduce)
        timer = setInterval(function () {
          show(i + 1);
        }, 5000);
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    dots.forEach(function (d, k) {
      d.addEventListener("click", function () {
        stop();
        show(k);
        start();
      });
    });
    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    show(0);
    start();
  });

  /* ---- Quiz: multi-step flow (select → continue → result) ---- */
  var quiz = document.querySelector("[data-quiz]");
  if (quiz) {
    var qSteps = Array.prototype.slice.call(
      quiz.querySelectorAll("[data-quiz-step]"),
    );
    var qResult = quiz.querySelector("[data-quiz-result]");
    var qFill = quiz.querySelector("[data-quiz-fill]");
    var qLabel = quiz.querySelector("[data-quiz-step-label]");
    var qNav = quiz.querySelector("[data-quiz-nav]");
    var qPrev = quiz.querySelector("[data-quiz-prev]");
    var qNext = quiz.querySelector("[data-quiz-next]");
    var qNextLabel = quiz.querySelector("[data-quiz-next-label]");
    var total = qSteps.length;
    var at = 0;
    var qGate = quiz.querySelector("[data-quiz-gate]");
    var qPairing = quiz.querySelector("[data-quiz-pairing]");
    var qForm = quiz.querySelector(".signup_form.is-quiz");
    var qError = quiz.querySelector("[data-quiz-error]");
    var captured = !qGate; /* no gate = always show pairing */

    quiz.querySelectorAll("[data-quiz-options]").forEach(function (group) {
      group.querySelectorAll("[data-quiz-option]").forEach(function (o) {
        o.addEventListener("click", function () {
          group.querySelectorAll("[data-quiz-option]").forEach(function (x) {
            x.classList.remove("is-selected");
          });
          o.classList.add("is-selected");
          if (qNext) qNext.disabled = false;
        });
      });
    });

    function stepChosen(i) {
      return !!qSteps[i].querySelector(".quiz-option.is-selected");
    }

    function render() {
      var done = at >= total;
      qSteps.forEach(function (s, i) {
        s.classList.toggle("is-active", i === at && !done);
      });
      if (qResult) qResult.classList.toggle("is-active", done);
      if (done) {
        if (qGate) qGate.hidden = captured;
        if (qPairing) qPairing.hidden = !captured;
      }
      if (qFill)
        qFill.style.width =
          (done ? 100 : Math.round(((at + 1) / total) * 100)) + "%";
      if (qLabel)
        qLabel.textContent = done
          ? "Complete"
          : "Step " + String(at + 1).padStart(2, "0") + " of " + total;
      if (qNav) qNav.style.display = done ? "none" : "flex";
      if (qPrev) qPrev.disabled = at === 0;
      if (qNext) qNext.disabled = !stepChosen(Math.min(at, total - 1));
      if (qNextLabel)
        qNextLabel.textContent =
          at === total - 1 ? "See my pairing" : "Continue";
    }
    qNext &&
      qNext.addEventListener("click", function () {
        if (at < total && !stepChosen(at)) return;
        at++;
        render();
        quiz.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    qPrev &&
      qPrev.addEventListener("click", function () {
        if (at > 0) {
          at--;
          render();
        }
      });
    var restart = quiz.querySelector("[data-quiz-restart]");
    restart &&
      restart.addEventListener("click", function () {
        at = 0;
        quiz.querySelectorAll(".quiz-option.is-selected").forEach(function (x) {
          x.classList.remove("is-selected");
        });
        render();
      });

    /* Email gate — subscribe via AJAX so the quiz keeps its state, then reveal the pairing. */
    if (qForm) {
      qForm.addEventListener("submit", function (e) {
        e.preventDefault();
        if (qError) qError.hidden = true;
        var btn = qForm.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;
        fetch(qForm.action, {
          method: "POST",
          body: new FormData(qForm),
          headers: { Accept: "text/html" },
        })
          .then(function (r) {
            if (!r.ok) throw new Error("bad");
            return r.text();
          })
          .then(function () {
            captured = true;
            render();
          })
          .catch(function () {
            if (qError) qError.hidden = false;
            if (btn) btn.disabled = false;
          });
      });
    }

    render();
  }

  /* ---- Chapters — scroll-pinned timeline (About). Progress within the tall
         section drives which chapter is active; the sticky rail stays put. ---- */
  var chaptersSection = document.querySelector("[data-chapters]");
  var chapterTrack = document.querySelector("[data-chapter-track]");
  var dotsList = document.querySelector("[data-chapter-dots]");
  if (chaptersSection && chapterTrack) {
    var chapters = Array.prototype.slice.call(
      chapterTrack.querySelectorAll(".chapter"),
    );
    var dots = dotsList
      ? Array.prototype.slice.call(dotsList.querySelectorAll(".chapters_dot"))
      : [];
    var n = chapters.length,
      curr = -1,
      cticking = false;
    function setChapter(idx) {
      if (idx === curr) return;
      curr = idx;
      chapters.forEach(function (c, i) {
        c.classList.toggle("is-active", i === idx);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle("is-active", i === idx);
        d.classList.toggle("is-passed", i < idx); // dots already scrolled past
      });
      // gold progress line grows from dot 0 to the active dot
      if (dotsList)
        dotsList.style.setProperty(
          "--rail-progress",
          (n > 1 ? (idx / (n - 1)) * 100 : 0) + "%",
        );
    }
    function updateChapters() {
      cticking = false;
      var rect = chaptersSection.getBoundingClientRect();
      var total = chaptersSection.offsetHeight - window.innerHeight; // scrollable range
      var scrolled = Math.min(Math.max(-rect.top, 0), total);
      var p = total > 0 ? scrolled / total : 0; // 0..1 across the section
      var idx = Math.min(n - 1, Math.floor(p * n));
      setChapter(idx);
    }
    function onChapScroll() {
      if (!cticking) {
        cticking = true;
        requestAnimationFrame(updateChapters);
      }
    }
    window.addEventListener("scroll", onChapScroll, { passive: true });
    window.addEventListener("resize", onChapScroll);
    setChapter(0);
    updateChapters();
  }

  /* ---- Swiper (centered carousel — About featured) ---- */
  /* ---- Story: pinned odometer, panels drive the active step ---- */
  var story = document.querySelector("[data-story]");
  if (story) {
    var odometer = story.querySelector("[data-story-odometer]");
    var panels = Array.prototype.slice.call(
      story.querySelectorAll("[data-story-panel]"),
    );
    var storyTabs = Array.prototype.slice.call(
      story.querySelectorAll("[data-story-tab]"),
    );

    if (panels.length) {
      var active = -1;
      var setStep = function (i) {
        if (i === active) return;
        active = i;
        if (odometer) odometer.style.setProperty("--story-index", i);
        panels.forEach(function (p, k) {
          p.classList.toggle("is-active", k === i);
        });
        storyTabs.forEach(function (t, k) {
          t.classList.toggle("is-active", k === i);
          t.setAttribute("aria-selected", k === i ? "true" : "false");
        });
      };

      /* the panel crossing the middle of the viewport wins */
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setStep(panels.indexOf(entry.target));
            }
          });
        },
        { rootMargin: "-50% 0px -50% 0px", threshold: 0 },
      );

      panels.forEach(function (p) {
        observer.observe(p);
      });
      setStep(0);

      storyTabs.forEach(function (tab, i) {
        tab.addEventListener("click", function () {
          panels[i].scrollIntoView({ behavior: "smooth", block: "center" });
        });
      });
    }
  }

  document.querySelectorAll("[data-swiper]").forEach(function (root) {
    var track = root.querySelector("[data-swiper-track]");
    var slides = Array.prototype.slice.call(
      root.querySelectorAll("[data-swiper-slide]"),
    );
    var prev = root.querySelector("[data-swiper-prev]");
    var next = root.querySelector("[data-swiper-next]");
    var dotsWrap = root.querySelector("[data-swiper-dots]");
    if (!track || !slides.length) return;
    var index = 0;
    var dots = slides.map(function (_, i) {
      var b = document.createElement("button");
      b.className = "swiper_dot";
      b.setAttribute("aria-label", "Go to slide " + (i + 1));
      b.addEventListener("click", function () {
        go(i);
      });
      dotsWrap && dotsWrap.appendChild(b);
      return b;
    });
    function go(i) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      var slideW = slides[0].getBoundingClientRect().width;
      var gap =
        parseFloat(
          getComputedStyle(track).columnGap ||
            getComputedStyle(track).gap ||
            24,
        ) || 24;
      track.style.transform = "translateX(" + -(slideW + gap) * index + "px)";
      slides.forEach(function (s, k) {
        s.classList.toggle("is-active", k === index);
      });
      dots.forEach(function (d, k) {
        d.classList.toggle("is-active", k === index);
      });
    }
    prev &&
      prev.addEventListener("click", function () {
        go(index - 1);
      });
    next &&
      next.addEventListener("click", function () {
        go(index + 1);
      });
    // drag / swipe
    var down = false,
      x0 = 0;
    track.addEventListener("pointerdown", function (e) {
      down = true;
      x0 = e.clientX;
    });
    window.addEventListener("pointerup", function (e) {
      if (!down) return;
      down = false;
      var dx = e.clientX - x0;
      if (Math.abs(dx) > 50) go(index + (dx < 0 ? 1 : -1));
    });
    // start position: honor data-swiper-start (default 0)
    var start = parseInt(root.getAttribute("data-swiper-start"), 10);
    if (isNaN(start)) start = 0;
    window.addEventListener("resize", function () {
      go(index);
    });
    go(Math.min(start, slides.length - 1));
  });

  /* ---- Shop filters + sort + load more ---- */
  /* ---- Collection filter panel ----
     Filtering and sorting are server-side (Shopify's own filter params), so
     this only wires up the ergonomics: submit on change, the mobile drawer,
     and the fallback category group that has no server param behind it. */
  (function () {
    var form = document.querySelector("[data-filter-form]");
    if (!form) return;

    var panel = form.querySelector("[data-filter-panel]");
    var backdrop = document.querySelector(".shop-sidebar_backdrop");
    var openBtn = form.querySelector("[data-filter-open]");
    var currentController = null;

    function buildFormUrl() {
      var action = form.getAttribute("action") || window.location.pathname;
      var cleanAction = action.split("#")[0].split("?")[0];
      var formData = new FormData(form);
      var params = new URLSearchParams();

      formData.forEach(function (val, key) {
        if (val !== "") {
          params.append(key, val);
        }
      });

      var query = params.toString();
      return cleanAction + (query ? "?" + query : "");
    }

    function fetchFilterData(targetUrl, updateHistory) {
      if (updateHistory === undefined) updateHistory = true;

      if (currentController) {
        currentController.abort();
      }
      currentController = new AbortController();

      form.classList.add("is-loading");

      // Remember which <details> filter groups are open by their header text
      var openMap = {};
      form.querySelectorAll("details.filter-group").forEach(function (d, i) {
        var summary = d.querySelector(".filter-group_summary span");
        var name = summary ? summary.textContent.trim() : "group-" + i;
        openMap[name] = d.open;
      });

      var fetchUrl = targetUrl.split("#")[0];

      fetch(fetchUrl, {
        signal: currentController.signal,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      })
        .then(function (res) {
          if (!res.ok) throw new Error("HTTP " + res.status);
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var newForm = doc.querySelector("[data-filter-form]");

          if (newForm) {
            // 1. Update sidebar body (options, counts)
            var currentBody = form.querySelector(".shop-sidebar_body");
            var newBody = newForm.querySelector(".shop-sidebar_body");
            if (currentBody && newBody) {
              currentBody.innerHTML = newBody.innerHTML;
            }

            // Restore which details groups were open
            form
              .querySelectorAll("details.filter-group")
              .forEach(function (d, i) {
                var summary = d.querySelector(".filter-group_summary span");
                var name = summary ? summary.textContent.trim() : "group-" + i;
                if (openMap[name] !== undefined) {
                  d.open = openMap[name];
                }
              });

            // 2. Update main content (toolbar, chips, product grid, pagination)
            var currentMain = form.querySelector(".shop-main");
            var newMain = newForm.querySelector(".shop-main");
            if (currentMain && newMain) {
              currentMain.innerHTML = newMain.innerHTML;
            }

            // 3. Update mobile trigger badge count
            var currentCount = form.querySelector(".shop-filter_trigger-count");
            var newCount = newForm.querySelector(".shop-filter_trigger-count");
            var triggerBtn = form.querySelector("[data-filter-open]");
            if (triggerBtn) {
              if (newCount) {
                if (currentCount) {
                  currentCount.textContent = newCount.textContent;
                } else {
                  var badge = document.createElement("span");
                  badge.className = "shop-filter_trigger-count";
                  badge.textContent = newCount.textContent;
                  triggerBtn.appendChild(badge);
                }
              } else if (currentCount) {
                currentCount.remove();
              }
            }

            // 4. Re-bind fallback filter listeners if any exist
            initFallbacks();
          }

          if (updateHistory) {
            window.history.pushState({ path: targetUrl }, "", targetUrl);
          }

          form.classList.remove("is-loading");
        })
        .catch(function (err) {
          if (err.name === "AbortError") return;
          console.error("Filter request failed, fallback reload:", err);
          form.classList.remove("is-loading");
          window.location.href = targetUrl;
        });
    }

    function applyFilters() {
      var targetUrl = buildFormUrl();
      fetchFilterData(targetUrl);
    }

    // Input changes (checkboxes, radios, native sort select)
    form.addEventListener("change", function (e) {
      var el = e.target;
      if (!el.name) return; // fallback client-only inputs
      if (el.classList.contains("filter-price_input")) return;
      applyFilters();
    });

    // Price range inputs (on blur change or Enter)
    form.addEventListener("change", function (e) {
      if (e.target.classList.contains("filter-price_input")) {
        applyFilters();
      }
    });
    form.addEventListener("keydown", function (e) {
      if (
        e.key === "Enter" &&
        e.target.classList.contains("filter-price_input")
      ) {
        e.preventDefault();
        applyFilters();
      }
    });

    // Intercept clicks on Clear All, Filter Chips, Reset, or Pagination links for AJAX no-refresh
    document.addEventListener("click", function (e) {
      var link = e.target.closest(
        "[data-filter-clear], .shop-chip, .shop-empty_reset, .shop-pagination a",
      );
      if (!link) return;
      if (
        !form.contains(link) &&
        !link.classList.contains("shop-sidebar_clear")
      )
        return;

      var href = link.getAttribute("href");
      if (!href || href === "#" || href.indexOf("javascript:") === 0) return;

      e.preventDefault();

      if (link.closest(".shop-pagination")) {
        var gridSec = document.getElementById("shop-grid");
        if (gridSec) gridSec.scrollIntoView({ behavior: "smooth" });
      }

      fetchFilterData(href);
    });

    // Handle browser back and forward buttons
    window.addEventListener("popstate", function () {
      fetchFilterData(window.location.href, false);
    });

    /* ---- Mobile drawer ---- */
    function openPanel() {
      panel && panel.classList.add("is-open");
      backdrop && (backdrop.hidden = false);
      document.body.classList.add("has-filter-open");
      openBtn && openBtn.setAttribute("aria-expanded", "true");
    }
    function closePanel() {
      panel && panel.classList.remove("is-open");
      backdrop && (backdrop.hidden = true);
      document.body.classList.remove("has-filter-open");
      openBtn && openBtn.setAttribute("aria-expanded", "false");
    }
    openBtn && openBtn.addEventListener("click", openPanel);
    document.querySelectorAll("[data-filter-close]").forEach(function (b) {
      b.addEventListener("click", closePanel);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closePanel();
    });

    /* ---- Fallback category and trait tag groups (client-only) ---- */
    function initFallbacks() {
      var catInputs = Array.prototype.slice.call(
        form.querySelectorAll("[data-cat-value]"),
      );
      var tagInputs = Array.prototype.slice.call(
        form.querySelectorAll("[data-tag-value]"),
      );
      if (!catInputs.length && !tagInputs.length) return;

      var grid = form.querySelector("[data-shop-grid]");
      var cards = grid
        ? Array.prototype.slice.call(grid.querySelectorAll("[data-product]"))
        : [];
      var countEl = form.querySelector("[data-shop-count]");
      var catBadge = form.querySelector("[data-cat-count]");
      var tagBadge = form.querySelector("[data-tag-count]");
      var emptyEl = form.querySelector("[data-shop-empty]");
      var baseCount = countEl ? countEl.textContent : "";

      function applyClientFilters() {
        var pickedCats = catInputs
          .filter(function (i) {
            return i.checked;
          })
          .map(function (i) {
            return i.getAttribute("data-cat-value");
          });
        var pickedTags = tagInputs
          .filter(function (i) {
            return i.checked;
          })
          .map(function (i) {
            return i.getAttribute("data-tag-value");
          });

        cards.forEach(function (c) {
          var type = c.getAttribute("data-type") || "";
          var rawTags = c.getAttribute("data-tags") || "";
          var tagsList = rawTags
            ? rawTags.split(",").map(function (t) {
                return t.trim();
              })
            : [];

          var catMatch =
            pickedCats.length === 0 || pickedCats.indexOf(type) !== -1;
          var tagMatch =
            pickedTags.length === 0 ||
            pickedTags.some(function (t) {
              return tagsList.indexOf(t) !== -1;
            });

          c.classList.toggle("is-filtered", !(catMatch && tagMatch));
        });

        if (catBadge) {
          catBadge.textContent = pickedCats.length;
          catBadge.hidden = pickedCats.length === 0;
        }
        if (tagBadge) {
          tagBadge.textContent = pickedTags.length;
          tagBadge.hidden = pickedTags.length === 0;
        }

        var totalPicks = pickedCats.length + pickedTags.length;
        var shown = cards.filter(function (c) {
          return !c.classList.contains("is-filtered");
        }).length;
        if (countEl) {
          countEl.textContent =
            totalPicks > 0
              ? shown + (shown === 1 ? " variety" : " varieties")
              : baseCount;
        }
        if (emptyEl) emptyEl.hidden = !(totalPicks > 0 && shown === 0);
      }

      catInputs.forEach(function (i) {
        i.addEventListener("change", applyClientFilters);
      });
      tagInputs.forEach(function (i) {
        i.addEventListener("change", applyClientFilters);
      });

      applyClientFilters();
    }

    initFallbacks();
  })();

  /* ---- Esc closes overlays ---- */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeSearch();
      closeCart();
      if (account) {
        account.classList.remove("is-open");
        accountBtn && accountBtn.setAttribute("aria-expanded", "false");
      }
      if (navComp) {
        navComp.classList.remove("is-menu-open");
        navToggle && navToggle.setAttribute("aria-expanded", "false");
      }
      document
        .querySelectorAll("[data-select].is-open")
        .forEach(function (sel) {
          sel.classList.remove("is-open");
          sel
            .querySelector("[data-select-toggle]")
            .setAttribute("aria-expanded", "false");
        });
    }
  });

  /* ---- Scroll morph: hero inset image zooms out into the story background
         (home only, DESKTOP only — disabled below 960px) ---- */
  if (!reduce && window.matchMedia("(min-width: 961px)").matches) {
    var inset = document.querySelector(".hero_inset");
    var story = document.querySelector(".section_story");
    var morph = document.querySelector(".scroll-morph");
    if (inset && story && morph) {
      var start = null,
        storyTop = 1,
        ticking = false;
      function measure() {
        var r = inset.getBoundingClientRect();
        start = {
          top: r.top + window.scrollY,
          left: r.left,
          w: r.width,
          h: r.height,
        };
        storyTop = Math.max(
          1,
          story.getBoundingClientRect().top + window.scrollY,
        );
      }
      function ease(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }
      function update() {
        ticking = false;
        if (!start) measure();
        var sy = window.scrollY;
        var p = Math.max(0, Math.min(1, sy / storyTop));
        if (p <= 0.001) {
          morph.style.display = "none";
          inset.style.opacity = "1";
          return;
        }
        if (p >= 0.999) {
          morph.style.display = "none";
          return;
        }
        var e = ease(p);
        var vw = window.innerWidth,
          vh = window.innerHeight;
        var sTop = start.top - sy;
        var top = sTop + (0 - sTop) * e;
        var left = start.left + (0 - start.left) * e;
        var w = start.w + (vw - start.w) * e;
        var h = start.h + (vh - start.h) * e;
        var op =
          p < 0.05 ? p / 0.05 : p > 0.82 ? Math.max(0, (1 - p) / 0.18) : 1;
        morph.style.display = "block";
        morph.style.left = left + "px";
        morph.style.top = top + "px";
        morph.style.width = w + "px";
        morph.style.height = h + "px";
        morph.style.borderRadius = 12 * (1 - e) + "px";
        morph.style.boxShadow =
          "0 " +
          24 * (1 - e) +
          "px " +
          60 * (1 - e) +
          "px rgba(17,17,17," +
          0.4 * (1 - e) +
          ")";
        morph.style.opacity = op;
        inset.style.opacity = "0";
      }
      function onScroll() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", function () {
        measure();
        update();
      });
      measure();
      update();
    }
  }

  /* ---- Farm gallery: arrow buttons + pointer drag ----
     The strip scrolls natively (overflow-x + scroll-snap); this only layers
     on the conveniences. Every page without a gallery no-ops. */
  document.querySelectorAll("[data-farm-gallery]").forEach(function (gallery) {
    var track = gallery.querySelector("[data-farm-track]");
    if (!track) return;

    function step() {
      var frame = track.querySelector(".farm-gallery_frame");
      return frame
        ? frame.getBoundingClientRect().width + 16
        : track.clientWidth * 0.8;
    }
    function scrollBy(dir) {
      track.scrollBy({
        left: dir * step(),
        behavior: reduce ? "auto" : "smooth",
      });
    }

    var prev = gallery.querySelector("[data-farm-prev]");
    var next = gallery.querySelector("[data-farm-next]");
    prev &&
      prev.addEventListener("click", function () {
        scrollBy(-1);
      });
    next &&
      next.addEventListener("click", function () {
        scrollBy(1);
      });

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev && prev.toggleAttribute("disabled", track.scrollLeft <= 0);
      next && next.toggleAttribute("disabled", track.scrollLeft >= max);
    }
    track.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();

    /* Drag to pan — mouse only; touch already pans natively. */
    var down = false,
      startX = 0,
      startLeft = 0;
    track.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "touch") return;
      down = true;
      startX = e.clientX;
      startLeft = track.scrollLeft;
      track.classList.add("is-dragging");
    });
    track.addEventListener("pointermove", function (e) {
      if (!down) return;
      e.preventDefault();
      track.scrollLeft = startLeft - (e.clientX - startX);
    });
    ["pointerup", "pointercancel", "pointerleave"].forEach(function (evt) {
      track.addEventListener(evt, function () {
        down = false;
        track.classList.remove("is-dragging");
      });
    });
    /* A drag that moved shouldn't also follow a link. */
    track.addEventListener("click", function (e) {
      if (Math.abs(track.scrollLeft - startLeft) > 4) e.preventDefault();
    });
  });

  /* ---- Wholesale Header Gallery Slider ---- */
  var wholesaleGallery = document.querySelector("[data-wholesale-gallery]");
  if (wholesaleGallery) {
    var slides = Array.prototype.slice.call(
      wholesaleGallery.querySelectorAll(".wholesale-hero_slide"),
    );
    var dots = Array.prototype.slice.call(
      wholesaleGallery.querySelectorAll("[data-wholesale-dot]"),
    );
    if (slides.length > 1) {
      var currentSlide = 0;
      var slideInterval = null;

      function goToSlide(idx) {
        currentSlide = (idx + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          s.classList.toggle("is-active", i === currentSlide);
        });
        dots.forEach(function (d, i) {
          d.classList.toggle("is-active", i === currentSlide);
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener("click", function () {
          goToSlide(i);
          resetAuto();
        });
      });

      function resetAuto() {
        if (slideInterval) clearInterval(slideInterval);
        slideInterval = setInterval(function () {
          goToSlide(currentSlide + 1);
        }, 5000);
      }
      resetAuto();
    }
  }
})();
